var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "ul",
    {
      staticClass: "widget-list widget-links sidebar-views",
    },
    [
      _c(
        "li",
        {
          class: {
            active: _vm.tableView,
          },
        },
        [
          _c(
            "a",
            {
              attrs: {
                href: "#",
              },
              on: {
                click: function click($event) {
                  $event.preventDefault()
                  return _vm.setTiledView(false)
                },
              },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$gettext("Tabellarische Ansicht")) +
                  "\n        "
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          class: {
            active: _vm.tilesView,
          },
        },
        [
          _c(
            "a",
            {
              attrs: {
                href: "#",
              },
              on: {
                click: function click($event) {
                  $event.preventDefault()
                  return _vm.setTiledView(true)
                },
              },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$gettext("Kachelansicht")) +
                  "\n        "
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }